<template>
	<v-container fluid class="grey lighten-5">
		<v-container grid-list-lg>
			<v-row justify-center row wrap class="good-cards">
				<v-col xs="12" sm="6" v-for="(item, idx) in items" :key="idx">
					<v-hover>
						<v-card slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`" :to="item.link" shaped>
							<v-card-title class="font-weight-black black--text text-xs-right">{{ item.title
							}}</v-card-title>

							<v-responsive>
								<v-img :src="item.image" height="300px"></v-img>
							</v-responsive>
							<!-- <v-flex fill-height> -->
							<v-card-text>
								<!-- <h3 class="font-weight-thin black--text text-xs-right mb-0">{{ item.desc }}</h3> -->
								<h3 class="font-weight-thin black--text text-xs-center">
									{{ item.desc }}
								</h3>
							</v-card-text>

							<v-card-actions>
								<v-btn text color="grey darken-2"
									class="font-weight-thin black--text text-xs-center mb-0" :to="item.link">{{
										item.btnCaption }}</v-btn>
							</v-card-actions>
							<!-- </v-flex> -->
						</v-card>
					</v-hover>
				</v-col>
			</v-row>
		</v-container>
		<p>&nbsp;</p>
	</v-container>
</template>

<script>
export default {
	name: "GoodCards",
	data() {
		return {
			items: [

				{
					image: require("@/assets/img/pazarcloud-main-card.jpg"),
					title: "پازارکلاد",
					desc: "",
					btnCaption: "مشاهده نسخه ها، ماژولها و قیمتهای هر یک",
					link: "/pazarcloud",
				},
				{
					image: require("@/assets/img/pazarplus-main-card.jpg"),
					title: "پازار پلاس",
					desc: "",
					btnCaption: "مشاهده نسخه ها، ماژولها و قیمتهای هر یک",
					link: "/pazarplus",
				},

				// {
				// 	image: require("@/assets/img/pazar12-main-card.jpg"),
				// 	title: "پازار نسخه 12",
				// 	desc: "",
				// 	btnCaption: "مشاهده نسخه ها، ماژولها و قیمتهای هر یک",
				// 	link: "/pazar12",
				// },

			],
		};
	},
};
</script>
